import React, { useState, useEffect } from "react";
import "./Amendments.css";
import { Title, Text, DatePickers, AmendmentsNote } from "../../../../Components";
import amendment from "../../../../assets/images/svg/amendments.svg";
import arrowRight from "../../../../assets/images/svg/arrowRight.svg";
import { Link } from "react-router-dom";
import { Modal } from 'react-bootstrap'; // Assuming you are using React-Bootstrap
import Skeleton from "react-loading-skeleton";
import axios from "axios";
import Cookies from 'js-cookie';
import { toast } from "react-toastify";

import Box from '@mui/material/Box';
import SubModal from '@mui/material/Modal';


const Amendments = ({ url, data, translations , language}) => {
  const [amendments, setAmendments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isClear, setIsClear] = useState(false);

  const [subPopup, setSubPopup] = useState(false);
  const [messagePopup, setMessagePopup] = useState("")   

  const handleClose = () => {
      setSubPopup(false);
  };

  const dashboardSection = data
    ? data?.find((item) => item.section === "Dashboard")
    : null;

  useEffect(() => {
    if (
      dashboardSection &&
      dashboardSection?.data &&
      dashboardSection?.data?.content &&
      dashboardSection?.data?.content?.amendments &&
      dashboardSection?.data?.content?.amendments?.objects
    ) {
      const amendmentsObjects = dashboardSection?.data?.content?.amendments?.objects.map(item => {
        return {
          ...item,
        };
      });

      setAmendments(amendmentsObjects);
      setLoading(false);
    }
  }, [dashboardSection]);


  const handleResetDate = () => {
    setSelectedDate(null); // Reset the selected date
    setIsClear(true);
  };

  const [selectedDate, setSelectedDate] = useState({ startDate: null, endDate: null });

  const handleDateChange = (date) => {
      if (!date || !date.startDate || !date.endDate) {
          // Handle the case where date or startDate or endDate is null
          return;
   }
    
      // Function to format date as "Y-%m-%d %H:%M:%S"
      const formatDate = (inputDate) => {
        if (!inputDate) return null;
        const year = inputDate.getFullYear();
        const month = (inputDate.getMonth() + 1).toString().padStart(2, '0');
        const day = inputDate.getDate().toString().padStart(2, '0');
    
        return `${year}-${month}-${day}`;
      };
    
      // Set time to midnight for the start date and format it
      const startDateTime = date.startDate ? formatDate(new Date(date.startDate)) : null;
    
      // Set time to midnight for the end date and format it
      const endDateTime = date.endDate ? formatDate(new Date(date.endDate)) : null;
    
      setSelectedDate({
        startDate: startDateTime,
        endDate: endDateTime
      });
    };
 
    useEffect(() => {
      if ((selectedDate && (selectedDate.startDate !== null || selectedDate.endDate !== null)) || (isClear && isClear === true )) {
        fetchData();
      }
    }, [selectedDate,isClear]);
  
    const fetchData = async () => {
      try {   

        let apiUrl = `${url}/api/method/projectx.projectx.doctype.recent_amendment.recent_amendment.amendment`;
        if (selectedDate && selectedDate.startDate && selectedDate.endDate) {
          apiUrl += `?&amendmentdate_start=${selectedDate.startDate}&amendmentdate_end=${selectedDate.endDate}`;
        }
        const apiKey = Cookies.get('api_key');
        const apiSecret = Cookies.get('api_secret');
    
        setLoading(true); // Start loading
        const response = await axios.get(apiUrl,{
          headers: {
            'Content-Type': 'application/json',
            Authorization: `token ${apiKey}:${apiSecret}`,
        },
        });

        if (response.data.status_code !== 200) {
          toast.error(translations?.message?.failedFetchData ? translations.message.failedFetchData :"Failed to fetch data. Please try again..");
        }
        
        if (response?.data?.status_code === 202) {
          setSubPopup(true);
        }

        const result = response?.data?.result;
        setAmendments(result?.objects?.slice(0, 3) ?? []);    
        setLoading(false); // End loading
      } catch (error) {
        if (error?.response?.data?.status_code === 202) {
          setSubPopup(true);
          setMessagePopup(error?.response?.data?.message)
        }
        toast.error(translations?.message?.failedFetchData ? translations.message.failedFetchData :"Failed to fetch data. Please try again..");
        console.error("Error fetching data:", error);
        setLoading(false); // End loading
      }
    };

  

  return (
    <div className="reminders">

      <Title
        icon={amendment}
        title={translations?.message?.amendment ? translations.message.amendment : "Amendments"} 
        showInfo={true}
        titleBtn={true}
        onDateChange={handleDateChange}
        onReset={handleResetDate}
        tooltip= {translations?.message?.amendmentsTooltip ? translations.message.amendmentsTooltip : `"Amendments" provide information about changes to legislation that the government has announced or passed.`} 
        translations={translations}
        //  It covers the previous 60 days, but you can change the date range to cover longer or shorter periods "todo"
        language={language}
     />
                <div className="mt-3 hide-responsive">
        <Text para={translations?.message?.byDateRange ? translations.message.byDateRange : "By data range:"}/>

      </div>
      <div className="mt-2 hide-responsive">
        <DatePickers
         inputType={"datetime"} 
         onDateChange={handleDateChange}
         onReset={handleResetDate}  
         translations={translations}
         language={language}
         
         />
      </div>
      {/* Date picker and other UI components */}
      
      <div className="note-container">
        {loading ?  (
          <>
            <div className="reminder-skelton">
              <div className="first-reminder-skelton">
                <Skeleton width={"100%"} height={18} />
                <Skeleton width={"100%"} height={13} />
              </div>
              <div className="first-reminder-skelton">
                <Skeleton width={"100%"} height={15} />
                <Skeleton width={"90%"} height={13} />
                <Skeleton width={"103%"} height={15} />
                <Skeleton width={"90%"} height={13} />
              </div>
            </div>
            <br />
            <div className="reminder-skelton">
              <div className="first-reminder-skelton">
                <Skeleton width={"100%"} height={18} />
                <Skeleton width={"100%"} height={13} />
              </div>
              <div className="first-reminder-skelton">
                <Skeleton width={"100%"} height={15} />
                <Skeleton width={"95%"} height={13} />
                <Skeleton width={"103%"} height={15} />
                <Skeleton width={"90%"} height={13} />
              </div>
            </div>
          </>
        ) : (
          <div className="dashboard-reminders">
            {amendments.length === 0 ? (
              <div className="not-found">{translations?.message?.noDataAvailable ? translations.message.noDataAvailable:"No data available."}</div>
            ) : (
              <>
                {amendments.map((amendment, index) => (
                  <AmendmentsNote 
                    key={index} 
                    value={amendment.name}
                    textTitle={amendment?.areas_of_laws
                        ? amendment?.areas_of_laws
                            .split(",")
                            .map((area) => area.trim())
                            .join(", ")
                        : ""}
                    noteCount={amendment.notes_count}
                    reminderCount={amendment.reminders_count}
                    reportCount={"0"}
                    url={url}
                    date={amendment.amendmentdate}
                    textDate={translations?.message?.inForceDate ? translations.message.inForceDate : "in Force Date"} 
                    title={amendment.amendment_citation}
                    onRefresh={fetchData}
                    titleLink={`/dashboard/regulation/${encodeURIComponent(amendment.id)}`}
                    legId={amendment.id}  
                    translations={translations}
                    language={language}
                    />
                ))}
          
                <div className="note-link-container">
                    <a href={"/dashboard/amendments"} className="note-link">
                    {translations?.message?.goToAmendmentsList ? translations.message.goToAmendmentsList : " Go To Amendments List"}<img src={arrowRight} alt="arrow" />
                    </a>
                </div>

                
                
              </>
            )}
          </div>
        )}
      </div>
    

        <SubModal
                open={subPopup}
                onClose={handleClose}
                aria-labelledby="child-modal-title"
                aria-describedby="child-modal-description"
                >
                <Box className="subpopup-container">
                    <p className='subpopup-text'>
                    {
                        messagePopup ? messagePopup : "your subscription has expired"
                    }
                    </p>
                    <a className='subpopup-link' href='/pricing'>Go To Pricing</a>
                </Box>
          </SubModal>
    </div>
  );
};

export default Amendments;
